import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class DetailedReportValidator {
    public atLeastOneFieldRequired(): ValidatorFn {
      return (formGroup: FormGroup) => {
        const requestFrom = formGroup.get('requestFrom');
        const requestTo = formGroup.get('requestTo');
        const requestDateFrom = formGroup.get('requestDateFrom');
        const requestDateTo = formGroup.get('requestDateTo');
        const division = formGroup.get('division');
        const chargeAfeCc = formGroup.get('chargeAfeCc');
        const requestStatus = formGroup.get('requestStatus');
        const requestType = formGroup.get('requestType');
        const employee = formGroup.get('employee');
        const approvedBy = formGroup.get('approvedBy');
        const approvedDateFrom = formGroup.get('approvedDateFrom');
        const approvedDateTo = formGroup.get('approvedDateTo');
        
        if (requestFrom.value === '' &&
            requestTo.value === '' &&
            requestDateFrom.value === '' &&
            requestDateTo.value === '' &&
            division.value === '' &&
            chargeAfeCc.value === '' &&
            requestStatus.value === '' &&
            requestType.value === '' &&
            employee.value === '' &&
            approvedBy.value === '' &&
            approvedDateFrom.value === '' &&
            approvedDateTo.value === '') {
          return { atLeastOneFieldRequired: "You must specify a value in at least one of the search fields." };
        }
      };
    }
  }